function createLookup<T extends { [key: string]: any }>(collection: T[], key = 'id'): Record<any, T> {
  return collection.reduce((acc, item) => ({ ...acc, [item[key]]: item }), {})
}

export default createLookup
